import { Skeleton } from '@mui/material';
import { useState } from 'react';

import { EditableHeader } from '@/components/form/EditableHeader/EditableHeader';

import { useDiagramEditorContext } from '../../contexts/diagramEditor.context';

/**
 * Shows the artifact name and renames the artifact when the user commits an
 * edit. A rename is independent of the diagram, so it is available while the
 * diagram generates or saves.
 */
export function DiagramEditorTitle() {
  const { name, loading, isRenaming, rename } = useDiagramEditorContext();
  // Changing this key remounts only the text field, so a blank, unchanged, or
  // failed name shows the saved name again. It is not the diagram revision,
  // and it is not sent to the backend.
  const [headerResetKey, setHeaderResetKey] = useState(0);

  const commit = async (nextName: string) => {
    await rename(nextName);
    setHeaderResetKey((key) => key + 1);
  };

  if (name === null) {
    if (loading) return <Skeleton width={240} height={32} />;
    // The artifact was deleted or could not load. The editor shows the error.
    return 'Diagram';
  }

  return (
    <EditableHeader
      key={headerResetKey}
      value={name}
      onChange={(nextName) => {
        void commit(nextName);
      }}
      disabled={isRenaming}
      typographyVariant="title-l"
      testId="Diagram-title"
      placeholder="Diagram name"
    />
  );
}
